import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    autoClose: Boolean,
  };

  connect() {
    if (this.autoCloseValue) {
      this.startTimer();
    }
  }

  close() {
    this.element.style.marginTop = `-${this.element.offsetHeight}px`;

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  startTimer() {
    this.timeout = setTimeout(() => {
      this.close();
    }, 5000);
  }

  clearTimer() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  disconnect() {
    this.clearTimer();
  }
}
